import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Empty, List, Skeleton } from "antd";
import { useMemo } from "react";
import { ListContentBlockerRow } from "./row.js";
import { useI18n } from "../../../contexts/i18n.js";
import { useListContentBlocker } from "../../../contexts/listContentBlocker.js";
const ListContentBlocker = ()=>{
    const { __ } = useI18n();
    const { busy, serviceCount, contentBlockerCount, rows, onCreate } = useListContentBlocker();
    const dataSourceSkeleton = useMemo(()=>{
        const d = [];
        for(let key = 0; key < contentBlockerCount; key++){
            d.push({
                key
            });
        }
        return d;
    }, [
        contentBlockerCount
    ]);
    const addText = __("Add content blocker");
    return contentBlockerCount ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "wp-clearfix",
                children: /*#__PURE__*/ _jsx("a", {
                    onClick: onCreate,
                    className: "button button-primary right",
                    style: {
                        marginBottom: 10
                    },
                    children: addText
                })
            }),
            busy ? /*#__PURE__*/ _jsx(List, {
                dataSource: dataSourceSkeleton,
                renderItem: ()=>/*#__PURE__*/ _jsx(List.Item, {
                        children: /*#__PURE__*/ _jsx(Skeleton, {
                            loading: true,
                            active: true,
                            paragraph: {
                                rows: 1
                            }
                        })
                    })
            }) : /*#__PURE__*/ _jsx(List, {
                children: rows.map((row)=>/*#__PURE__*/ _createElement(ListContentBlockerRow, {
                        ...row,
                        key: row.attributes.id.toString()
                    }))
            })
        ]
    }) : /*#__PURE__*/ _jsx(Empty, {
        description: serviceCount > 0 ? __("You have not yet created a content blocker.") : __("Because a content blocker must be associated with a service, you must create a service first."),
        children: /*#__PURE__*/ _jsx("a", {
            className: "button button-primary",
            onClick: onCreate,
            children: addText
        })
    });
};
export { ListContentBlocker };
